'use strict';

var base = require('wishlists/product/wishlist');

var exportDetails = $.extend({}, base, {});

module.exports = exportDetails;
